/**
 * Parses tool events from streaming text
 * Extracts embedded tool events in the format <<<TOOL_EVENT:{...}>>>
 * @param {string} text - The text containing potential tool events
 * @returns {Object} { cleanText: string, events: ToolEvent[] }
 */
export function parseToolEvents(text) {
  const toolEventRegex = /<<<TOOL_EVENT:(.*?)>>>/g;
  const events = [];
  let cleanText = text;
  let match;

  while ((match = toolEventRegex.exec(text)) !== null) {
    try {
      const event = JSON.parse(match[1]);
      // Normalize unknown tool types to 'unknown' to avoid prop-type warnings
      const allowed = new Set([
        'd3_visualization',
        'mermaid_diagram',
        'content_retrieval',
        'geogebra_visualization',
        'threejs_visualization',
        'web_search',
        'unknown',
      ]);
      if (event && event.toolType && !allowed.has(event.toolType)) {
        event.toolType = 'unknown';
      }
      events.push(event);
      cleanText = cleanText.replace(match[0], '');
    } catch (e) {
      console.error('Failed to parse tool event:', e);
    }
  }

  return { cleanText: cleanText.trim(), events };
}

/**
 * Tool event type definitions
 * @typedef {Object} ToolEvent
 * @property {'tool_invocation' | 'tool_completion'} type - Event type
 * @property {string} toolName - Name of the tool
 * @property {'d3_visualization' | 'mermaid_diagram' | 'content_retrieval' | 'geogebra_visualization' | 'threejs_visualization' | 'web_search' | 'unknown'} toolType - Type of tool
 * @property {'started' | 'completed' | 'failed'} status - Current status
 * @property {string} timestamp - ISO timestamp
 * @property {any} [args] - Arguments passed to the tool
 * @property {any} [result] - Result from the tool (only for completion events)
 */
